module.exports = __webpack_public_path__ + "img/male-food@2x.0f6e4bff.png";